import { createContext, useContext } from "react"

const VTableContext = createContext()
VTableContext.displayName = "VirtualizedTableContext"

export { VTableContext }
export const useTableCtx = () => useContext(VTableContext)
